import { ReactElement, useEffect, useState } from 'react';
import cc from 'classcat';
import {
  TWO_WAY_OUTCOME_SPORTS,
  USA_SPEC_SPORTS
} from 'utils/constants/sportsbook/usa-specific-sports';
import { createArray } from 'utils/helpers/create-fake-array';
import { isMobile } from 'utils/is-mobile';
import { ESportsbookPageTypes } from 'interfaces/sportsbook-configs';
import { Skeleton } from 'newcomponents/UI/Skeleton';
import { useSportsbookConfigs } from 'hooks/sportsbook/useSportsbookConfigs';
import '../../index.less';

type TMatchCardInlineUSASkeletonProps = {
  sportAlias?: string;
  hideMoreWages?: boolean;
  detailedTeamsInfo?: boolean;
};

const matchCardInlineUSASkeletonDefaultProps = {
  sportAlias: undefined
} as TMatchCardInlineUSASkeletonProps;

const MATCH_CARD_INLINE_USA_LENGTH = 3;

export const MatchCardInlineUSASkeleton = ({
  sportAlias,
  hideMoreWages,
  detailedTeamsInfo
}: TMatchCardInlineUSASkeletonProps = matchCardInlineUSASkeletonDefaultProps): ReactElement => {
  const configs = useSportsbookConfigs();
  const isLive = configs.pageType === ESportsbookPageTypes.live;

  const [isClassic, setIsClassic] = useState(
    USA_SPEC_SPORTS.includes(sportAlias || '')
  );

  const [isClassicColumn, setIsClassicColumn] = useState(
    TWO_WAY_OUTCOME_SPORTS.includes(sportAlias || '')
  );

  useEffect(() => {
    setIsClassic(USA_SPEC_SPORTS.includes(sportAlias || ''));
    setIsClassicColumn(TWO_WAY_OUTCOME_SPORTS.includes(sportAlias || ''));
  }, [sportAlias]);

  return (
    <>
      <div
        className={cc([
          'matchCardInline__wrapper--usa',
          {
            'matchCardInline__wrapper--usa--withBorderRadius': isLive
          }
        ])}
      >
        <div className="matchCardInline__info">
          <div
            className={cc([
              'matchCardInline__leftGameInfo',
              {
                'matchCardInline__leftGameInfo--detailedView': detailedTeamsInfo
              }
            ])}
          >
            {detailedTeamsInfo && (
              <Skeleton.Avatar
                size="small"
                active
                shape="circle"
                style={{ marginRight: '4px', marginLeft: '8px' }}
              />
            )}
            <Skeleton
              title={{ style: { height: 6, width: 80, margin: '5px auto' } }}
              paragraph={false}
              active
            />
          </div>
          <div className="matchCardInline__teamNames">
            <div>
              {detailedTeamsInfo && (
                <Skeleton.Avatar
                  size="small"
                  active
                  shape="circle"
                  style={{ marginRight: '4px', marginLeft: '8px' }}
                />
              )}
              <Skeleton
                title={{ style: { height: 6, width: 80, margin: '5px auto' } }}
                paragraph={false}
                active
              />
            </div>
            <div>
              {detailedTeamsInfo && (
                <Skeleton.Avatar
                  size="small"
                  active
                  shape="circle"
                  style={{ marginRight: '4px', marginLeft: '8px' }}
                />
              )}
              <Skeleton
                title={{ style: { height: 6, width: 80, margin: '5px auto' } }}
                paragraph={false}
                active
              />
            </div>
          </div>
        </div>
        <div className="matchCardInline__odds">
          <div className="matchCardInline__oddsWrapper">
            {createArray(
              isClassicColumn ? 2 : MATCH_CARD_INLINE_USA_LENGTH
            ).map(event => (
              <div
                key={event}
                className={cc([
                  'matchCardInline__oddGroup',
                  {
                    'matchCardInline__oddGroup--mobile': isMobile()
                  }
                ])}
              >
                <div className="matchCardInline__marketName">
                  <Skeleton
                    title={{
                      style: {
                        height: 5,
                        width: isClassicColumn ? 0 : '10px',
                        margin: '5px auto'
                      }
                    }}
                    paragraph={false}
                    active
                  />
                </div>
                <Skeleton
                  title={{
                    style: { height: 5, width: 30, margin: '5px auto' }
                  }}
                  paragraph={false}
                  active
                />
                {isClassic && (
                  <Skeleton
                    title={{
                      style: { height: 5, width: 30, margin: '5px auto' }
                    }}
                    paragraph={false}
                    active
                  />
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
      {!hideMoreWages && (
        <div
          className={cc([
            'matchCardInline__moreWages',
            { 'matchCardInline__moreWages--mobile': isMobile() }
          ])}
        >
          {detailedTeamsInfo && (
            <Skeleton
              title={{
                style: { height: 16, width: 60, margin: '0', marginLeft: '4px' }
              }}
              paragraph={false}
              active
            />
          )}
          <Skeleton
            title={{
              style: { height: 5, width: 80, margin: '0', marginLeft: '80%' }
            }}
            paragraph={false}
            active
          />
        </div>
      )}
    </>
  );
};
